export type ChatToolbarAction =
  | 'export'
  | 'copy-transcript'
  | 'rename'
  | 'delete'
  | 'clear-history'
  | 'settings'
  | 'learn-from-session'

const CHAT_TOOLBAR_ACTION_EVENT = 'chat-toolbar-action'

export function dispatchChatToolbarAction(
  threadId: string,
  action: ChatToolbarAction,
): void {
  window.dispatchEvent(
    new CustomEvent(CHAT_TOOLBAR_ACTION_EVENT, {
      detail: { threadId, action },
    }),
  )
}

export function chatToolbarActionEventName(): string {
  return CHAT_TOOLBAR_ACTION_EVENT
}
